import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

/**
 * Initializes global Lenis smooth scrolling.
 * Exposes the Lenis instance globally as window.lenis.
 * Synchronizes Lenis with GSAP ScrollTrigger and the GSAP animation ticker.
 */
const initLenis = () => {
  // Initialize Lenis
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    orientation: 'vertical',
    gestureOrientation: 'vertical',
    smoothWheel: true,
    wheelMultiplier: 1,
    infinite: false,
  });

  // Expose Lenis globally (useful for GSAP scrollTrigger, manual scrolling etc.)
  window.lenis = lenis;

  // 1. Update ScrollTrigger on every scroll event
  lenis.on('scroll', ScrollTrigger.update);

  // 2. Use GSAP ticker to drive Lenis updates (eliminates duplicate animation loops)
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000); // convert seconds to milliseconds
  });

  // 3. Disable native lag smoothing for perfect synchronization
  gsap.ticker.lagSmoothing(0);

  console.log('Lenis Smooth Scrolling & GSAP ScrollTrigger Synchronized.');
  return lenis;
};

export default initLenis;
